<template>
  <label class="hs-file-upload" :class="{ 'is-dragging': isDragging }">
    <input
      ref="input"
      type="file"
      :accept="accept"
      :multiple="multiple"
      @change="handleFiles"
      @dragenter="isDragging = true"
      @dragleave="isDragging = false"
    />
    <hs-icon name="upload-cloud" tone="primary" soft box-size="3.5rem" :size="24" />
    <strong>{{ title }}</strong>
    <span>{{ description }}</span>
    <small v-if="fileNames">{{ fileNames }}</small>
  </label>
</template>

<script>
import HsIcon from "./HsIcon.vue";

export default {
  name: "HsFileUpload",
  components: { HsIcon },
  props: {
    modelValue: { type: [File, Array], default: null },
    accept: { type: String, default: "" },
    multiple: { type: Boolean, default: false },
    title: { type: String, default: "Choose file" },
    description: { type: String, default: "Drag a file here or click to browse." },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return { isDragging: false };
  },
  computed: {
    fileNames() {
      const files = Array.isArray(this.modelValue) ? this.modelValue : this.modelValue ? [this.modelValue] : [];
      return files.map((file) => file?.name).filter(Boolean).join(", ");
    },
  },
  methods: {
    handleFiles(event) {
      const files = Array.from(event.target.files || []);
      const value = this.multiple ? files : files[0] || null;
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
      this.isDragging = false;
    },
  },
};
</script>

<style scoped>
.hs-file-upload {
  align-items: center;
  background:
    radial-gradient(circle at 50% 0%, color-mix(in srgb, var(--hs-primary, #3293ec) 10%, transparent), transparent 34%),
    color-mix(in srgb, var(--hs-surface, #ffffff) 90%, transparent);
  border: 1px dashed color-mix(in srgb, var(--hs-primary, #3293ec) 28%, var(--hs-border, rgba(148, 163, 184, 0.22)));
  border-radius: 24px;
  cursor: pointer;
  display: grid;
  gap: 0.45rem;
  justify-items: center;
  padding: 1.5rem;
  text-align: center;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.hs-file-upload input {
  display: none;
}

.hs-file-upload:hover,
.hs-file-upload.is-dragging {
  border-color: var(--hs-primary, #3293ec);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.hs-file-upload strong {
  color: var(--hs-text, #0f172a);
  font-weight: 950;
}

.hs-file-upload span,
.hs-file-upload small {
  color: var(--hs-muted, #64748b);
  font-size: 0.82rem;
  font-weight: 700;
}

.hs-file-upload small {
  color: var(--hs-primary, #3293ec);
}
</style>
